import axios from "axios";

const usePost = async ({ url, method, payload, promise }) => {
  try {
    if (url) {
      const data = await axios({
        url,
        method,
        data: payload,
      });
      return [data, null];
    }

    const { data } = await promise;
    return [data, null];
  } catch (error) {
    return [null, error];
  }
};

export default usePost;
